
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { deserialize, dataMember, required, typedArray } from 'santee-dcts';
import { SponsorStudy } from './sponsor-study';
import { Settings } from '../core';

export class SponsorStudiesReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorStudy)
    public studies: SponsorStudy[];
}

@Injectable()
export class SponsorStudiesStorage {

    private readonly sponsorStudyUrl = '/sponsor/study';
    private studies: Observable<SponsorStudy[]> = null;


    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public saveStudyIsFavorite(study: SponsorStudy) {
        return this.http
            .post(`${this.settings.apiUrl}${this.sponsorStudyUrl}/favorite`, { protocolId: study.protocolId, isFavorite: study.isFavorite })
            .toPromise();
    }

    public loadStudies(reload: boolean = false) {
        if (!this.studies || reload) {
            this.studies = this.http
                .get(`${this.settings.apiUrl}${this.sponsorStudyUrl}`)
                .pipe(
                    map((rawStudies) => deserialize(rawStudies, SponsorStudiesReadModel).studies),
                    publishLast(),
                    refCount()
                );
        }

        return this.studies;
    }
}